<template>
  <div class="row main-content">
    <SocialBar/>
    <CreditosComponent/>
  </div>
</template>

<script>
import CreditosComponent from './components/CreditosComponent.vue';
import SocialBar from './components/SocialBar.vue';


export default {
  name: 'Nosotros',
  components: {
    SocialBar,
    CreditosComponent
  }
}

</script>